import { Popconfirm } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt } from 'react-icons/fa';
import Button from '~/components/Button';
import Can from '~/components/Can';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';

export const customersColumns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (text, record) => (
          <div>
            <Strong>{i18next.t('screens:default.name')}:</Strong> {record.name}
            <br />
            <Strong>{i18next.t('screens:customers.customerType')}:</Strong>{' '}
            {record.customer_type === 1 ? 'Jurídica' : 'Física'}
            <br />
            <Strong>{i18next.t('screens:customers.prospectType')}:</Strong>{' '}
            {record.prospect_type === 1
              ? 'Inativo'
              : record.prospect_type === 0
                ? 'Ativo'
                : record.prospect_type === 2
                  ? 'A prospectar'
                  : 'Indefinido'}
            <br />
            <Strong>{i18next.t('screens:default.city')}:</Strong> {record.city?.name || ''}
            <br />
            <Strong>{i18next.t('screens:default.responsible')}:</Strong> {record.responsible?.name || ''}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@clients/edit">
                <Button size="small" title={i18next.t('screens:default.edit')} onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@clients/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title={i18next.t('screens:default.delete')}>
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:default.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => record.name,
    },
    {
      title: i18next.t('screens:customers.customerType'),
      dataIndex: 'customer_type',
      key: 'customer_type',
      render: (text, record) => {
        return record.customer_type === 1 ? 'Jurídica' : 'Física';
      },
    },
    {
      title: i18next.t('screens:customers.prospectType'),
      dataIndex: 'prospect_type',
      key: 'prospect_type',
      render: (text, record) => {
        return record.prospect_type === 1
          ? 'Inativo'
          : record.prospect_type === 0
            ? 'Ativo'
            : record.prospect_type === 2
              ? 'A prospectar'
              : 'Indefinido';
      },
    },
    {
      title: i18next.t('screens:default.city'),
      dataIndex: 'cidade',
      key: 'cidade',
      render: (text, record) => record.city?.name || '',
    },
    {
      title: i18next.t('screens:default.responsible'),
      dataIndex: 'responsavel',
      key: 'responsavel',
      render: (text, record) => record.responsible?.name || '',
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (text, record) => (
        <TableActions align="center" justify="center">
          <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@clients/edit">
            <Button size="small" title={i18next.t('screens:default.edit')} onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@clients/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title={i18next.t('screens:default.delete')}>
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};
